export default __webpack_public_path__ + "static/media/simple_slider_honesty.ca722c86.png";